const React = require("react");
const T = React.PropTypes;

const baseStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 10,
    backgroundColor: "rgba(255, 255, 255, .6)",
    border: "1px solid #aaa"
};

const Locker = React.createClass({
    propTypes: {
        style: T.object
    },
    getDefaultProps(){
        return {
            style: {}
        }
    },
    render() {
        const style = Object.assign({}, baseStyle, this.props.style);

        return (<div style={style}>&nbsp;</div>);
    }
});

module.exports = Locker;


// WEBPACK FOOTER //
// ./src/components/Locker.jsx